import Component from './ng_applicant_add_dialog.vue'
export default Component
